import React from "react";
import { ProductPreviewContainer } from "../../../../styled/setting";

const ProductPreview = ({ product, options }) => {
  // console.log(options);
  return (
    <ProductPreviewContainer>
      <div className="tit">
        <span>상품 미리보기</span>
      </div>
      <div className="cont">
        <img
          src={
            typeof product?.media?.[0] === "string"
              ? imgHandler(product?.media?.[0])
              : imgHandler(product?.media?.[0]?.path)
          }
          onError={(e) => (e.target.src = "/img/icon_function_4.png")}
        />
        <div className="board">
          <span className="name">{product?.name}</span>
          <span className="desc">{product?.shortDescription}</span>
          <div className="price">
            <span>가격</span>
            <span>{product?.price ? formatNumber(toNumber(product.price || 0)) : 0}원</span>
          </div>
        </div>
      </div>
      {options && options.length > 0 && (
        <div className="options">
          {options.map((opt) => (
            <div className="opt">
              <p>
                <strong>{opt.name}</strong>
                <span>{opt.isRequired ? "필수" : "선택"}옵션</span>
              </p>
              <ul>
                {opt.options.map((item) => (
                  <li>
                    <span>{item.value}</span>
                    <span>+{formatNumber(item?.addPrice || 0)}원</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      )}
    </ProductPreviewContainer>
  );
};

export default ProductPreview;
